import { clsx } from 'clsx'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { StandProfilesPanel } from 'page/ProfileScreen/StandProfilesPanel/StandProfilesPanel'
import { useEffect, useRef } from 'react'
import { opt } from 'store/opt'
import { stand } from 'store/stand'
import css from './ProfileHeader.module.scss'

export const ProfileHeader = observer(() => {
  const compact = stand.compact && css.compact
  const largeRef = useRef<HTMLDivElement>(null)
  const pad = 24

  useEffect(() => {
    const large = largeRef.current
    if (!large) return

    const update = () => {
      stand.large = large.offsetHeight + pad * 2
    }

    const observer = new ResizeObserver(update)
    observer.observe(large)
    update()

    return () => {
      observer.disconnect()
      stand.large = undefined
    }
  }, [])

  if (opt.single) return <Vertical gap={24} pad={[pad, 0]} center>
    <Typo size={24} medium upper>
      {i18n('stand.MyProfile')}
    </Typo>
  </Vertical>

  return <Vertical className={css.root} pad={[pad, 0]} center>
    <Vertical ref={largeRef} className={clsx(css.large, compact)} gap={24} center>
      <Typo size={24} medium upper center>
        {i18n('stand.MyProfiles')}
      </Typo>
      <StandProfilesPanel />
    </Vertical>
    <Vertical className={clsx(css.small, compact)} gap={24}>
      <StandProfilesPanel compact />
    </Vertical>
  </Vertical>
})
